.paper {
  max-width: 430px;
  margin: 0 auto;
  background-color: #ffffff;
  color: var(--ink);
  font-family: var(--font-body);
  position: relative;
  overflow-wrap: break-word;
  box-shadow: 0 0 44px rgba(70, 55, 30, 0.16), 0 0 6px rgba(70, 55, 30, 0.06);
}

/* 문서 구조에는 있어야 하지만 디자인 원본에는 놓일 자리가 없는 제목. */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

.progressBoundary {
  width: 0;
  height: 0;
  pointer-events: none;
}
